"use strict";
function _classCallCheck(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var n = e[i];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      "value" in n && (n.writable = !0),
      Object.defineProperty(t, n.key, n);
  }
}
function _createClass(t, e, i) {
  return (
    e && _defineProperties(t.prototype, e),
    i && _defineProperties(t, i),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    t
  );
}
var triggerAnimation = new CustomEvent("triggerAnimation"),
  openFilter = new CustomEvent("openFilter"),
  closeFilter = new CustomEvent("closeFilter"),
  changeFilter = new CustomEvent("changeFilter");
function randomIntFromInterval(t, e) {
  return Math.floor(Math.random() * (e - t + 1) + t);
}
function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}
var Filter = (function () {
  function e() {
    _classCallCheck(this, e),
      (this.filter = document.querySelector(".collection--filter")),
      this.filter
        ? ((this.filterTop = document.querySelector(
            ".collection--filter__top"
          )),
          (this.filterContent = document.querySelector(
            ".collection--filter__content"
          )),
          (this.filterBtn = document.querySelector(".collection--filter__btn")),
          (this.baseUrl = this.filter.dataset.url),
          (this.params = new URLSearchParams(window.location.search)),
          (this.menuTypeBtns = this.filter.querySelectorAll(
            ".collection--filter__menu--item"
          )),
          (this.clearBtn = this.filter.querySelector(".clear-filter")),
          (this.viewResultsBtn = this.filter.querySelector(
            ".filter-view-results"
          )),
          (this.backButtons = this.filter.querySelectorAll(
            ".collection--filter__options--back"
          )),
          (this.state = {
            filterOpen: !1,
            filterView: "collection",
            category: [],
            gender: [],
            designer: [],
          }),
          (this.sortby = this.filter.querySelector(".sortby")),
          (this.body = document.querySelector("body")),
          (this.gridResults = document.querySelector(".collection--grid")),
          (this.body = document.querySelector("body")),
          (this.mobCurrentDesigner = document.querySelector(
            ".mob-current--designer"
          )),
          (this.mobCurrentCategory = document.querySelector(
            ".mob-current--category"
          )),
          (this.mobCurrentGender = document.querySelector(
            ".mob-current--gender"
          )),
          (this.calcHeight = this.calcHeight.bind(this)),
          this._init())
        : setTimeout(function () {
            new e();
          }, 500);
  }
  return (
    _createClass(e, [
      {
        key: "_init",
        value: function () {
          var t = this;
          this.viewResultsBtn
            ? this.filter.classList.contains("init") ||
              (this.filter.classList.add("init"),
              this.filterBtn.addEventListener("click", function () {
                t.filterContent.classList.remove("viewOptions"),
                  t.filterContent.classList.contains("open")
                    ? ((t.state.filterOpen = !1),
                      t.filterContent.classList.remove("open"),
                      t.gridResults.classList.remove("filterOpen"),
                      document.dispatchEvent(closeFilter),
                      992 <= window.innerWidth &&
                        ((t.filterContent.style.transition = "none"),
                        (t.filterContent.style.height = "".concat(
                          t.filterContent.scrollHeight,
                          "px"
                        )),
                        setTimeout(function () {
                          t.filterContent.style.removeProperty("transition"),
                            (t.filterContent.style.height = 0),
                            setTimeout(function () {
                              t.filterContent.style &&
                                (t.filterContent.style = "");
                            }, 600);
                        }, 50)))
                    : (t.filterContent.classList.add("open"),
                      t.gridResults.classList.add("filterOpen"),
                      document.dispatchEvent(openFilter),
                      992 <= window.innerWidth &&
                        ((t.filterContent.style.height = 0),
                        (t.filterContent.style.height = "".concat(
                          t.filterContent.scrollHeight,
                          "px"
                        )),
                        setTimeout(function () {
                          t.filterContent.style && (t.filterContent.style = "");
                        }, 600)),
                      (t.state.filterOpen = !0)),
                  t.filterTop.classList.toggle("open"),
                  t.updateState();
              }),
              this.clickHandlers(),
              this.initialState(),
              window.innerWidth < 992 &&
                (this.calcHeight(),
                window.addEventListener("resize", this.calcHeight)))
            : setTimeout(function () {
                new e();
              }, 500);
        },
      },
      {
        key: "calcHeight",
        value: function () {
          this.filterContent.style.setProperty(
            "--viewHeight",
            "".concat(window.innerHeight - 120, "px")
          );
        },
      },
      {
        key: "initialState",
        value: function () {
          var t = this.params.get("category"),
            t =
              (t && (this.state.category = t.split(",")),
              this.params.get("gender")),
            t =
              (t && (this.state.gender = t.split(",")),
              this.params.get("designer"));
          t && (this.state.designer = t.split(",")),
            "true" == this.params.get("filterOpen") &&
              (this.filterContent.classList.add("open"),
              this.filterTop.classList.add("open"),
              this.gridResults.classList.add("filterOpen")),
            this.updateState();
        },
      },
      {
        key: "clickHandlers",
        value: function () {
          var n = this,
            i = "/collections/all",
            t = this.filterContent.querySelectorAll("[data-href]"),
            e = this.filterContent.querySelectorAll(".category-option"),
            s = this.filterContent.querySelectorAll(".gender-option"),
            r = this.filterContent.querySelectorAll(".designer-option"),
            t =
              (t.forEach(function (e) {
                e.addEventListener("click", function (t) {
                  t.preventDefault(),
                    e.classList.contains("active")
                      ? i !== e.dataset.href &&
                        (window.location.href = "".concat(i))
                      : (window.location.href = "".concat(e.dataset.href));
                });
              }),
              e.forEach(function (i) {
                i.addEventListener("click", function (t) {
                  t.preventDefault();
                  var e = i.dataset.val;
                  i.classList.contains("active")
                    ? (n.state.category = n.state.category.filter(function (t) {
                        return t !== e;
                      }))
                    : n.state.category.push(e),
                    n.updateState();
                });
              }),
              s.forEach(function (i) {
                i.addEventListener("click", function (t) {
                  t.preventDefault();
                  var e = i.dataset.val;
                  i.classList.contains("active")
                    ? (n.state.gender = n.state.gender.filter(function (t) {
                        return t !== e;
                      }))
                    : n.state.gender.push(e),
                    n.updateState();
                });
              }),
              r.forEach(function (i) {
                i.addEventListener("click", function (t) {
                  t.preventDefault();
                  var e = i.dataset.val;
                  i.classList.contains("active")
                    ? (n.state.designer = n.state.designer.filter(function (t) {
                        return t !== e;
                      }))
                    : n.state.designer.push(e),
                    n.updateState();
                });
              }),
              this.menuTypeBtns &&
                this.menuTypeBtns.forEach(function (t) {
                  var e = t.dataset.type || "";
                  n.filter.querySelector(
                    '.collection--filter__options[data-type="'.concat(e, '"]')
                  ) &&
                    t.addEventListener("click", throttle(function () {
                      (n.state.filterView = e),
                        n.filterContent.classList.add("viewOptions"),
                        n.updateState();
                    }, 1000));
                }),
              this.clearBtn.addEventListener("click", function () {
                n.clearBtn.classList.contains("full-reset")
                  ? (window.location.href = i)
                  : ((n.state.category = []),
                    (n.state.gender = []),
                    (n.state.designer = []),
                    n.updateState());
              }),
              this.sortby.addEventListener("click", function (t) {
                t.stopPropagation(), n.sortby.classList.toggle("open");
              }),
              this.sortby.querySelectorAll(".sortby__option"));
          t &&
            t.forEach(function (e) {
              e.addEventListener("click", function (t) {
                t.stopPropagation(),
                  n.params.set("sort_by", e.dataset.val),
                  n.updateState(!0);
              });
            }),
            this.body.addEventListener("click", function () {
              n.sortby.classList.contains("open") &&
                n.sortby.classList.remove("open");
            }),
            this.backButtons.forEach(function (t) {
              t.addEventListener("click", function () {
                n.filterContent.classList.remove("viewOptions");
              });
            }),
            this.viewResultsBtn.addEventListener("click", function () {
              n.filterContent.classList.remove("open"),
                n.filterTop.classList.remove("open"),
                n.gridResults.classList.remove("filterOpen"),
                window.scrollTo(0, 0);
            }),
            this.body.addEventListener("click", function () {
              n.body.classList.contains("filterOpen") &&
                (n.filterContent.classList.remove("open"),
                n.filterTop.classList.remove("open"),
                n.gridResults.classList.remove("filterOpen"));
            }),
            this.filter.addEventListener("click", function (t) {
              return t.stopPropagation();
            });
        },
      },
      {
        key: "updateState",
        value: function () {
          var e = this,
            t = 0 < arguments.length && void 0 !== arguments[0] && arguments[0],
            i = this.filter.querySelector(
              '.collection--filter__options[data-type="'.concat(
                this.state.filterView,
                '"]'
              )
            ),
            n =
              (i &&
                !i.classList.contains("active") &&
                document.dispatchEvent(changeFilter),
              this.state.filterOpen
                ? this.body.classList.add("filterOpen")
                : this.body.classList.remove("filterOpen"),
              this.filterContent.querySelectorAll(".category-option")),
            s = this.filterContent.querySelectorAll(".gender-option"),
            r = this.filterContent.querySelectorAll(".designer-option"),
            n =
              (n.forEach(function (t) {
                e.state.category.includes(t.dataset.val)
                  ? t.classList.add("active")
                  : t.classList.remove("active");
              }),
              s.forEach(function (t) {
                e.state.gender.includes(t.dataset.val)
                  ? t.classList.add("active")
                  : t.classList.remove("active");
              }),
              r.forEach(function (t) {
                e.state.designer.includes(t.dataset.val) ||
                t.classList.contains("reset-default")
                  ? t.classList.add("active")
                  : t.classList.remove("active");
              }),
              0 < this.state.category.length
                ? this.params.set("category", this.state.category)
                : this.params.delete("category"),
              0 < this.state.gender.length
                ? this.params.set("gender", this.state.gender)
                : this.params.delete("gender"),
              0 < this.state.designer.length
                ? this.params.set("designer", this.state.designer)
                : this.params.delete("designer"),
              this.filter.querySelector(
                '.collection--filter__menu--item[data-type="'.concat(
                  this.state.filterView,
                  '"]'
                )
              )),
            s = this.filter.querySelector(
              ".collection--filter__options.active"
            ),
            r = this.filter.querySelector(
              ".collection--filter__menu--item.active"
            );
          s && s.classList.remove("active"),
            r && r.classList.remove("active"),
            i && i.classList.add("active"),
            n && n.classList.add("active"),
            "" !== this.params.toString()
              ? window.history.replaceState(
                  null,
                  null,
                  window.location.pathname + "?" + this.params.toString()
                )
              : window.history.replaceState(
                  null,
                  null,
                  window.location.pathname
                ),
            t && window.location.reload(),
            this.updateDisplay();
        },
      },
      {
        key: "updateDisplay",
        value: function () {
          var l = this,
            t = document.querySelectorAll(".collection--grid__item"),
            e = document.querySelector(".collection--grid__empty"),
            i = this.filter.querySelector(".current-category"),
            n = this.filter.querySelector("#filterCat"),
            s = this.filter.querySelector(".current-gender"),
            r = this.filter.querySelector("#filterGender"),
            o = this.filter.querySelector(".current-designer"),
            a = this.filter.querySelector("#filterDesigner"),
            c = 0;
          0 < this.state.gender.length ||
          0 < this.state.category.length ||
          0 < this.state.designer.length
            ? ((this.clearBtn.style.display = "flex"),
              this.filterContent.classList.add("hasFilter"))
            : (this.clearBtn.classList.contains("full-reset") ||
                (this.clearBtn.style.display = "none"),
              this.filterContent.classList.remove("hasFilter")),
            0 < this.state.gender.length
              ? ((s.style.display = "block"),
                (r.innerHTML = this.state.gender[0]),
                (this.mobCurrentGender.innerHTML = this.state.gender[0]),
                1 < this.state.gender.length &&
                  ((r.innerHTML = ""
                    .concat(r.innerHTML, " +")
                    .concat(this.state.gender.length - 1, " More")),
                  (this.mobCurrentGender.innerHTML = ""
                    .concat(this.mobCurrentGender.innerHTML, " +")
                    .concat(this.state.gender.length - 1, " More"))))
              : ((s.style.display = "none"),
                (r.innerHTML = ""),
                (this.mobCurrentGender.innerHTML = "")),
            0 < this.state.category.length
              ? ((i.style.display = "block"),
                (n.innerHTML = this.state.category[0]),
                (this.mobCurrentCategory.innerHTML = this.state.category[0]),
                1 < this.state.category.length &&
                  ((n.innerHTML = ""
                    .concat(n.innerHTML, " +")
                    .concat(this.state.category.length - 1, " More")),
                  (this.mobCurrentCategory.innerHTML = ""
                    .concat(this.mobCurrentCategory.innerHTML, " +")
                    .concat(this.state.category.length - 1, " More"))))
              : ((i.style.display = "none"),
                (n.innerHTML = ""),
                (this.mobCurrentCategory.innerHTML = "")),
            0 < this.state.designer.length
              ? ((o.style.display = "block"),
                (a.innerHTML = this.state.designer[0].replace(
                  "Designer: ",
                  ""
                )),
                (this.mobCurrentDesigner.innerHTML =
                  this.state.designer[0].replace("Designer: ", "")),
                1 < this.state.designer.length &&
                  ((a.innerHTML = ""
                    .concat(a.innerHTML, " +")
                    .concat(this.state.designer.length - 1, " More")),
                  (this.mobCurrentDesigner.innerHTML = ""
                    .concat(this.mobCurrentDesigner.innerHTML, " +")
                    .concat(this.state.designer.length - 1, " More"))))
              : ((o.style.display = "none"),
                (a.innerHTML = ""),
                (this.mobCurrentDesigner.innerHTML = "")),
            t &&
              0 !== t.length &&
              (t.forEach(function (t) {
                var e,
                  i,
                  n,
                  s = !0,
                  r = t.dataset.collections.split("|"),
                  o = t.dataset.type.toUpperCase(),
                  a = t.dataset.designer.toUpperCase() || "notset";
                0 < l.state.gender.length &&
                  ((e = !1),
                  l.state.gender.forEach(function (t) {
                    r.includes(t) && (e = !0);
                  }),
                  e || (s = !1)),
                  0 < l.state.category.length &&
                    ((i = !1),
                    l.state.category.forEach(function (t) {
                      o === t.toUpperCase() && (i = !0);
                    }),
                    i || (s = !1)),
                  0 < l.state.designer.length &&
                    ((n = !1),
                    l.state.designer.forEach(function (t) {
                      a === t.toUpperCase() && (n = !0);
                    }),
                    n || (s = !1)),
                  s
                    ? (t.classList.remove("hide"), c++)
                    : t.classList.add("hide");
              }),
              (e.style.display = null !== e && 0 < c ? "none" : "block"),
              (this.viewResultsBtn.innerHTML = "View (".concat(c, ") items")),
              (s = document
                .querySelector(".collection--grid")
                .querySelectorAll(".animate-show")) &&
                s.forEach(function (t) {
                  t.classList.remove("animate-show"),
                    t.classList.remove("init");
                }),
              document.dispatchEvent(triggerAnimation));
        },
      },
    ]),
    e
  );
})();
function docReady(t) {
  "complete" === document.readyState || "interactive" === document.readyState
    ? setTimeout(t, 1)
    : document.addEventListener("DOMContentLoaded", t);
}
var FilterTextAnimate = (function () {
  function n(t, e, i) {
    _classCallCheck(this, n),
      (this.element = t),
      (this.srcText = t.textContent),
      (this.allCharacters =
        "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~"),
      (this.autoDistort = !1),
      (this.eventStart = e),
      (this.eventEnd = i),
      (this.isAnimating = false),
      this._init();
  }
  return (
    _createClass(n, [
      {
        key: "_init",
        value: function () {
          var e = this;
          this.eventStart.forEach(function (t) {
            document.addEventListener(t, function () {
              if (!e.isAnimating) {
                e.start();
                setTimeout(function () {
                  e.end();
                }, 400);
              }
            });
          }),
            this.eventEnd &&
              document.addEventListener(this.eventEnd, function () {
                e.end();
              });
        },
      },
      {
        key: "distort",
        value: function () {
          for (var t, e = "", i = 0; i < this.srcText.length; i++)
            " " === this.srcText[i]
              ? (e += " ")
              : ((t = randomIntFromInterval(0, this.allCharacters.length - 1)),
                (e += this.allCharacters[t]));
          this.element.textContent = e;
        },
      },
      {
        key: "start",
        value: function () {
          var t = this;
          if (!this.isAnimating) {
            this.isAnimating = true;
            this.autoDistort = setInterval(function () {
              t.distort();
            }, 40);
          }
        },
      },
      {
        key: "end",
        value: function () {
          var t = this;
          if (this.isAnimating) {
            clearInterval(this.autoDistort);
            this.isAnimating = false;
            setTimeout(function () {
              t.element.textContent = t.srcText;
            }, 50);
          }
        },
      },
    ]),
    n
  );
})();
docReady(function () {
  new Filter();
  var t = document.querySelectorAll(".filter-item-main-text"),
    e = document.querySelectorAll(".filter-item-main-option");
  t &&
    t.forEach(function (t) {
      new FilterTextAnimate(t, ["openFilter"], "closeFilter");
    }),
    e &&
      e.forEach(function (t) {
        new FilterTextAnimate(t, ["openFilter", "changeFilter"], !1);
      });
});
